'use client'
import styled from 'styled-components'
import { ReactNode, useState } from 'react'
import { commonStyles } from '../../../utils/commonStyles'
import { XImage } from '../../views/common/XImage'
import { Images } from '../../../utils/images'
import { useFilterContext } from './FilterContext'
import CheckBox from '../../views/common/CheckBox'
import { Top } from '../../../utils/type'

export default function ItemsFilter(props: { enableRarity?: boolean }) {
  return (
    <FilterWrapper>
      <StatusFilter />
      {props.enableRarity && <AAAityFilter />}
      <PriceFilter />
    </FilterWrapper>
  )
}

const FilterWrapper = styled.div`
  width: 248px;
  background: #0f0f0f;
  height: 100%;
`

function StatusFilter() {
  const { showAll, setShowAll } = useFilterContext()
  return (
    <FilterItem name={'Status'} defaultOpen>
      <StatusWrapper>
        <StatusCheckItem onClick={() => setShowAll(false)}>
          <CheckBox checked={!showAll} style={{ marginRight: 8 }} />
          <StatusText>Only Buy Now</StatusText>
        </StatusCheckItem>
        <StatusCheckItem onClick={() => setShowAll(true)}>
          <CheckBox checked={showAll} style={{ marginRight: 8 }} />
          <StatusText>Show All</StatusText>
        </StatusCheckItem>
      </StatusWrapper>
    </FilterItem>
  )
}

const StatusWrapper = styled.div`
  padding: 10px 20px;
  position: relative;
`

const StatusCheckItem = styled.div`
  height: 24px;
  ${commonStyles.flexStart}
  cursor: pointer;
  &:not(first-child) {
    margin-top: 10px;
  }
`

const StatusText = styled.span`
  font-size: 13px;
  color: #9e9e9e;
`

function AAAityFilter() {
  const { top, onTopChange } = useFilterContext()
  return (
    <FilterItem name={'RARITY'}>
      <SelectItemsWrapper>
        {[Top.Top_1, Top.TOP_10, Top.TOP_25].map((x) => (
          <SelectItem key={x} selected={top === x} onClick={() => (top === x ? onTopChange(Top.ALL) : onTopChange(x))}>
            TOP {x}%
          </SelectItem>
        ))}
      </SelectItemsWrapper>
    </FilterItem>
  )
}

const SelectItemsWrapper = styled.div`
  padding: 0 20px;
  padding-top: 10px;
  ${commonStyles.flexBetween};
`

const SelectItem = styled.span<{ selected?: boolean }>`
  width: 66px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid ${(props) => (props.selected ? '#F5D802' : '#404040')};
  text-align: center;
  font-size: 13px;
  color: ${(props) => (props.selected ? '#F5D802' : '#666')};
  cursor: pointer;
  line-height: 30px;
  transition: all 0.2s linear;
`

function PriceFilter() {
  const { priceMin, setPriceMin } = useFilterContext()
  const { priceMax, setPriceMax } = useFilterContext()
  return (
    <FilterItem name={'PRICE'}>
      <PriceFilterWrapper>
        <InputItem name={'MIN'} value={priceMin} onChange={setPriceMin} />
        <InputItem name={'MAX'} value={priceMax} onChange={setPriceMax} />
      </PriceFilterWrapper>
    </FilterItem>
  )
}

const PriceFilterWrapper = styled.div`
  padding: 0 20px;
  padding-top: 10px;
  ${commonStyles.flexStart};
  flex-direction: column;
  position: relative;
`
function InputItem(props: { name: string; value?: string; onChange: (val: string) => void }) {
  return (
    <InputItemWrapper>
      <Label>
        {props.name}
        <BtcIcon />
      </Label>
      <Input value={props.value} onChange={(e) => props.onChange(e.target.value)} />
    </InputItemWrapper>
  )
}
const InputItemWrapper = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
  border: 1px solid #404040;
  ${commonStyles.flexBetween};
  &:last-child {
    margin-top: -1px;
  }
`
const Label = styled.span`
  display: inline-block;
  background: #2e2e2e;
  width: 104px;
  height: 100%;
  color: #666;
  font-size: 13px;
  line-height: 18px;
  padding-right: 26px;
  ${commonStyles.flexEnd};
`
const Input = styled.input`
  width: 104px;
  flex: 1;
  padding-left: 13px;
  font-size: 13px;
  color: #fff;
  line-height: 40px;
  background: transparent;
  outline: none;
  border: none;
`
const BtcIcon = styled(XImage).attrs({
  src: Images.PROJECT.BTC_GRAY_SVG,
})`
  width: 14px;
  height: 14px;
  margin-left: 4px;
`

function FilterItem(props: { name: string; defaultOpen?: boolean; children?: ReactNode }) {
  const [isOpen, setIsOpen] = useState(props.defaultOpen)
  return (
    <FilterItemWrapper>
      <FilterTitle isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <span>{props.name}</span>
        <Angle isOpen={isOpen} />
      </FilterTitle>
      {isOpen && props.children}
    </FilterItemWrapper>
  )
}

const FilterItemWrapper = styled.div`
  position: relative;
  margin-bottom: 10px;
`

const FilterTitle = styled.div<{ isOpen?: boolean }>`
  height: 40px;
  padding: 0 20px;
  cursor: pointer;
  ${commonStyles.flexBetween};
  font-size: 14px;
  background: ${(props) => (props.isOpen ? '#343434' : 'transparent')};
  color: #fff;
  user-select: none;
  transition: all 0.2s linear;
  &:hover {
    background: #343434;
  }
`

const Angle = styled(XImage).attrs({
  src: Images.PROJECT.ANGLE_SVG,
})<{ isOpen?: boolean }>`
  width: 14px;
  height: 8px;
  transform: rotate(${(props) => (props.isOpen ? 180 : 0)}deg);
`
